import { Box, Collapse, Divider, HStack, Tooltip, useToast, VStack, } from '@chakra-ui/react';
import React, { useState } from 'react';
import useGenericMutationUseCase from '../../../hooks/usecases/generic/useGenericMutationUseCase';
import { useSubmitAiFeedback } from '../../../services/api/generated/client';
import { capitalise } from '../../../services/text/format';
import { AiFeedbackContext } from '../../../types/enums/AiFeedbackContext';
import { localise } from '../../../services/lang/lang';
import RatingButton from './RatingButton';
import { useTokens } from '../../../context/TokenProvider';
import NegativeRatingFormWrapper from './NegativeRatingFormWrapper';
import SuspenseWrapper from '../SuspenseWrapper/SuspenseWrapper';
import InfoOutlineIcon from '../../icons/InfoOutlineIcon/InfoOutlineIcon';
const AiAssistRating = ({ model, type, onSubmitFeedback, handleExpand, feedback, }) => {
    const [isShowingForm, setIsShowingForm] = useState(false);
    const tokens = useTokens();
    const toast = useToast();
    const [submittedSentiment, setSubmittedSentiment] = useState(feedback?.sentiment);
    const handleShowForm = (showForm) => {
        setIsShowingForm(showForm);
        handleExpand(showForm);
    };
    const submitFeedback = useGenericMutationUseCase(useSubmitAiFeedback);
    const capitalised = capitalise(type);
    const feedbackableType = `App\\Models\\${capitalised}`;
    const handleSubmitFeedback = (sentiment, description, reasons, helpers) => {
        submitFeedback.execute({
            data: {
                ai_feedback_context_id: AiFeedbackContext.SUMMARY,
                feedbackable_id: model.id,
                feedbackable_type: feedbackableType,
                sentiment,
                description,
                reasons,
            },
        }, helpers, {
            onSuccess: () => {
                toast({
                    title: localise('AI_RATING_THANK_YOU'),
                    status: 'success',
                    isClosable: true,
                    duration: 1500,
                });
                helpers?.resetForm();
                setSubmittedSentiment(sentiment);
                onSubmitFeedback();
                if (sentiment === 'negative') {
                    handleShowForm(false);
                }
            },
        });
    };
    const { isPending } = submitFeedback;
    const hasNegativeRating = submittedSentiment === 'negative';
    const hasPositiveRating = submittedSentiment === 'positive';
    return (React.createElement(VStack, { w: "100%", spacing: tokens.Spacing04 },
        React.createElement(Box, { alignSelf: "flex-start" },
            React.createElement(HStack, { spacing: tokens.Spacing06, "data-testid": "ai_assist_ratings" },
                React.createElement(Tooltip, { "aria-label": localise('AI_ASSIST_INFO'), label: localise('AI_ASSIST_INFO'), placement: "bottom-start", hasArrow: true },
                    React.createElement(Box, null,
                        React.createElement(InfoOutlineIcon, null))),
                React.createElement(RatingButton, { variant: "positive", "data-testid": "thumb_up_button", isFilled: hasPositiveRating, isDisabled: hasPositiveRating || isPending, onClick: () => handleSubmitFeedback('positive'), label: localise('AI_SUMMARY_USEFUL') }),
                React.createElement(RatingButton, { variant: "negative", "data-testid": "thumb_down_button", isFilled: hasNegativeRating, isDisabled: hasNegativeRating || isPending, onClick: () => {
                        handleShowForm(!isShowingForm);
                    }, label: localise('AI_SUMMARY_NOT_USEFUL') }))),
        React.createElement(Collapse, { in: isShowingForm, animateOpacity: true, style: { width: '100%' } },
            React.createElement(Box, { w: "100%" },
                React.createElement(Divider, { variant: "grey", mb: tokens.Spacing04 }),
                React.createElement(SuspenseWrapper, null,
                    React.createElement(NegativeRatingFormWrapper, { onCancel: () => handleShowForm(false), onSubmit: (values, helpers) => {
                            handleSubmitFeedback('negative', values.description, values.reasons, helpers);
                        } }))))));
};
export default React.memo(AiAssistRating);
